import { Region } from '../../../integrated-client/models/Region';

export type RegionsList = Array<Region>;
export class ResultsData {

  items: RegionsList
  total?: number

  constructor() {
    this.items = [];
  }

}
